__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dataone";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@dataone/icons", "0.0.0", () => (Promise.all([__webpack_require__.e(5641), __webpack_require__.e(3299), __webpack_require__.e(812)]).then(() => (() => (__webpack_require__(53299))))));
			register("@dataone/lib", "0.0.0", () => (Promise.all([__webpack_require__.e(1970), __webpack_require__.e(9400), __webpack_require__.e(5641), __webpack_require__.e(2468), __webpack_require__.e(6558), __webpack_require__.e(2605)]).then(() => (() => (__webpack_require__(82900))))));
			register("@stripe/react-stripe-js", "2.9.0", () => (Promise.all([__webpack_require__.e(5682), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(45682))))));
			register("@stripe/stripe-js", "2.4.0", () => (__webpack_require__.e(9903).then(() => (() => (__webpack_require__(19903))))));
			register("@tanstack/react-query", "4.36.1", () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(77399))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(1732), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(31732))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(3079), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(63079))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(4571), __webpack_require__.e(5204), __webpack_require__.e(5641), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(75204))))));
			register("react", "18.3.1", () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(72176))))));
			register("sockjs-client", "1.6.1", () => (__webpack_require__.e(4374).then(() => (() => (__webpack_require__(14374))))));
			register("stompjs", "2.3.3", () => (__webpack_require__.e(3349).then(() => (() => (__webpack_require__(53349))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(5296), __webpack_require__.e(5641), __webpack_require__.e(9552)]).then(() => (() => (__webpack_require__(55296))))));
			register("styled-components", "6.1.15", () => (Promise.all([__webpack_require__.e(9162), __webpack_require__.e(5641)]).then(() => (() => (__webpack_require__(49162))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(7400).then(() => (() => (__webpack_require__(17400))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};